import { createPortal } from 'react-dom';

/**
 * Renders children into document.body so `position: fixed` overlays/modals are
 * always relative to the viewport — never trapped by an ancestor that creates a
 * containing block (transform / filter / backdrop-filter / perspective).
 */
export default function Portal({ children }) {
  if (typeof document === 'undefined') return null;
  return createPortal(children, document.body);
}
